export const GUARANTEED_EARNINGS_WRONG_ZIP_ERROR: string = 'wrong_zip_code'
export const NON_MARKET_ERROR = "DoorDash isn't in your area yet!"

export const CANADA_BACKGROUND_CHECK_URL =
  'https://checkr.com/apply/doordash/113f9fbf4be'

export const CANADA_HELP_URL =
  'https://help.doordash.com/dashers/s/article/Canada-Dasher-Sign-Up'

export const DASHER_APP_URL = 'https://www.doordash.com/dasher/app/'
export const IOS_DASHER_APP_URL =
  'https://itunes.apple.com/us/app/doordash-dasher/id1451754591'
export const ANDROID_DASHER_APP_URL =
  'https://play.google.com/store/apps/details?id=com.doordash.driverapp'
export const STATES = {
  AL: 'Alabama',
  AK: 'Alaska',
  AZ: 'Arizona',
  AR: 'Arkansas',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DE: 'Delaware',
  DC: 'District Of Columbia',
  FL: 'Florida',
  GA: 'Georgia',
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PA: 'Pennsylvania',
  PR: 'Puerto Rico',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VA: 'Virginia',
  WA: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming',
}

export const CANADA_PROVINCES = {
  NL: 'Newfoundland and Labrador',
  PE: 'Prince Edward Island',
  NS: 'Nova Scotia',
  NB: 'New Brunswick',
  QC: 'Quebec',
  ON: 'Ontario',
  MB: 'Manitoba',
  SK: 'Saskatchewan',
  AB: 'Alberta',
  BC: 'British Columbia',
  YT: 'Yukon',
  NT: 'Northwest Territories',
  NU: 'Nunavut',
}

export const STATE_CODES = [
  ...Object.keys(STATES).map(key => ({
    name: key,
    value: key,
  })),
]

export const CANADA_PROVINCE_CODES = [
  ...Object.keys(CANADA_PROVINCES).map(key => ({
    name: key,
    value: key,
  })),
]

export const SupplyAcquisitionMethods = {
  DROPSHIPPING: 'DROPSHIPPING',
  GO_INTO_OFFICE: 'GO_INTO_OFFICE',
}

// TODO(swat-team): This is a hack so that Australian dashers can sign up.
// We will remove it once we implement international phone numbers.
export const AU_COUNTRY_CODE = '+61'

export const BASE_JOBS_URL = `https://doordash.com/dasher/driving-opportunities`
export const BASE_PATH = `/dasher/driving-opportunities`

export const AWS_BASE = `https://cdn.doordash.com`
export const CLOUDFLARE_BASE = `https://img.cdn4dd.com/cdn-cgi/image`
export const CLOUDFLARE_DEFAULT_PARAMS = `fit=contain,format=auto,quality=75`
export const CLOUDFLARE_DEFAULT_BASE = `${CLOUDFLARE_BASE}/${CLOUDFLARE_DEFAULT_PARAMS}`

export const JOB_1 = `Part-time driver`
export const JOB_2 = `Delivery driver`
export const JOB_3 = `Food delivery driver`
export const JOB_4 = `Food courier`
export const JOB_SUFFIX = `opportunity`

export const JOB_TYPE_1 = `part-time-driver`
export const JOB_TYPE_2 = `delivery-driver`
export const JOB_TYPE_3 = `food-delivery-driver`
export const JOB_TYPE_4 = `food-courier`

export const JOBS = [JOB_1, JOB_2, JOB_3, JOB_4]
export const JOB_TYPES = [JOB_TYPE_1, JOB_TYPE_2, JOB_TYPE_3, JOB_TYPE_4]

export enum CheckrStatus {
  WAITING = 'WAITING',
  DELAYED = 'DELAYED',
  NEEDS_ATTENTION = 'NEEDS_ATTENTION',
  CLEAR = 'CLEAR',
}

export const REDCARD_POLL_INTERVAL = 750 // second (750 ms)
export const TIMEOUT_TRIES = 5 // seconds

export const IOS_REDCARD_DEEPLINK = `comdoordashdriver://onboarding/completed`
export const ANDROID_REDCARD_DEEPLINK = `dddriver://onboarding/completed`
export const IOS_CLOSE_DEEPLINK = `comdoordashdriver://onboarding/completed`

// TODO: Replace this deeplink when we have a proper close deeplink
// Using the current completed deeplink affects Android analytics
export const ANDROID_CLOSE_DEEPLINK = `dddriver://onboarding/completed`

export const AU_ZIPCODE_PATTERNS = new RegExp(/^[0-9]{4}$/)
export const CA_ZIPCODE_PATTERNS = new RegExp(
  /([ABCEGHJKLMNPRSTVXY]\d)([ABCEGHJKLMNPRSTVWXYZ]\d){2}/i
)
export const US_ZIPCODE_PATTERNS = new RegExp(/^[0-9]{5}(-[0-9]{4})?$/)

export enum ConfirmationStepTrackingKeys {
  BACKGROUNDCHECK = 'background_check',
  ACTIVATIONKIT = 'activation_kit',
  REDCARDACTIVATION = 'red_card_activation',
  STARTDASHING = 'start_dashing',
  PAYMENTACCOUNTSETUP = 'add_bank_account',
  FASTPAY = 'fast_pay_setup',
}

export enum ConfirmationStepKeys {
  BACKGROUNDCHECK = 'backgroundCheckComplete',
  ACTIVATIONKIT = 'activationKit',
  PAYMENTACCOUNTSETUP = 'paymentAccountSetupComplete',
  REDCARDACTIVATION = 'redCardActivationComplete',
  STARTDASHING = 'firstDeliveryComplete',
  FASTPAY = 'fastPaySetupComplete',
}

export const COUNTRY_SHORTCODES = {
  US: 'US',
  CA: 'CA',
  AU: 'AU',
}

export const PR_MARKET_ID = 187

export const RED_CARD = 'red-card'

export const IN_APP_EDUCATION_SUB = 'in-app-education'

export const INSTANT_DASH_SPLASH_SUB = 'instant-dash-splash'

export const ACTIVATION_KIT_SPLASH_SUB = 'activation-kit-splash'

export const FAST_PAY_SUB = 'fast-pay'

export const DD_READY_FIRST_DASH_TS = 'dd_ready_first_dash_ts'

export const SEVEN_DAYS = 7 * 24 * 60 * 60

export const DASHER_ACTIVATION_HELP =
  // tslint:disable-next-line:max-line-length
  'https://help.doordash.com/dashers/s/article/About-the-Dasher-Activation-Kit?#tracking'

export const IDENTIFY_TIMEOUT = 5000

export const UTM_SOURCE = 'UTM_SOURCE'

export const FIRST_DASH_VIDEO_URL =
  'https://cdn.doordash.com/media/dasher/first_dash.mp4'
export const FIRST_DASH_VIDEO_EN_TRACK_URL =
  'https://cdn.doordash.com/media/dasher/first_dash_en.vtt'

export const CAR_MODELS = {
  Audi: [
    'A3',
    'A4',
    'A4 allroad',
    'A5',
    'A6',
    'A6 allroad',
    'A7',
    'A8',
    'e-tron',
    'Q3',
    'Q5',
    'Q7',
    'Q8',
    'R8',
    'RS 3',
    'RS 5',
    'S3',
    'S4',
    'S5',
    'S8',
    'SQ5',
    'TT',
  ],
  GMC: [
    'Acadia',
    'Canyon Crew Cab',
    'Canyon Extended Cab',
    'Savana 2500 Cargo',
    'Savana 2500 Passenger',
    'Savana 3500 Cargo',
    'Savana 3500 Passenger',
    'Sierra 1500 Crew Cab',
    'Sierra 1500 Double Cab',
    'Sierra 1500 Limited Double Cab',
    'Sierra 1500 Regular Cab',
    'Sierra 2500 HD Crew Cab',
    'Sierra 2500 HD Double Cab',
    'Sierra 2500 HD Regular Cab',
    'Sierra 3500 HD Crew Cab',
    'Terrain',
    'Yukon',
    'Yukon XL',
  ],
  Hyundai: [
    'Accent',
    'Elantra',
    'Elantra GT',
    'Ioniq Electric',
    'Ioniq Hybrid',
    'Ioniq Plug-in Hybrid',
    'Kona',
    'Kona Electric',
    'NEXO',
    'Palisade',
    'Santa Fe',
    'Santa Fe XL',
    'Sonata',
    'Sonata Hybrid',
    'Sonata Plug-in Hybrid',
    'Tucson',
    'Veloster',
    'Venue',
  ],
  Honda: [
    'Accord',
    'Accord Hybrid',
    'Civic',
    'Civic Type R',
    'Clarity Electric',
    'Clarity Fuel Cell',
    'Clarity Plug-in Hybrid',
    'CR-V',
    'Fit',
    'HR-V',
    'Insight',
    'Odyssey',
    'Passport',
    'Pilot',
    'Ridgeline',
  ],
  'Mercedes-Benz': [
    'A-Class',
    'C-Class',
    'CLA',
    'CLS',
    'E-Class',
    'G-Class',
    'GLA',
    'GLB',
    'GLC',
    'GLC Coupe',
    'GLE',
    'GLS',
    'Mercedes-AMG C-Class',
    'Mercedes-AMG CLA',
    'Mercedes-AMG CLS',
    'Mercedes-AMG E-Class',
    'Mercedes-AMG G-Class',
    'Mercedes-AMG GLA',
    'Mercedes-AMG GLC',
    'Mercedes-AMG GLC Coupe',
    'Mercedes-AMG GLE',
    'Mercedes-AMG GLE Coupe',
    'Mercedes-AMG GLS',
    'Mercedes-AMG GT',
    'Mercedes-AMG S-Class',
    'Mercedes-AMG SL',
    'Mercedes-AMG SLC',
    'Mercedes-Maybach S-Class',
    'Metris Cargo',
    'Metris Passenger',
    'Metris WORKER Cargo',
    'Metris WORKER Passenger',
    'S-Class',
    'SL',
    'SLC',
    'Sprinter 2500 Cargo',
    'Sprinter 2500 Crew',
    'Sprinter 2500 Passenger',
    'Sprinter 3500 Cargo',
    'Sprinter 3500 Crew',
    'Sprinter 3500 XD Cargo',
    'Sprinter 4500 Crew',
  ],
  Nissan: [
    'Altima',
    'Armada',
    'Frontier Crew Cab',
    'Frontier King Cab',
    'GT-R',
    'Kicks',
    'LEAF',
    'Maxima',
    'Murano',
    'NV1500 Cargo',
    'NV200',
    'NV2500 HD Cargo',
    'NV3500 HD Cargo',
    'NV3500 HD Passenger',
    'Pathfinder',
    'Rogue',
    'Rogue Sport',
    'Sentra',
    'Titan Crew Cab',
    'Titan King Cab',
    'TITAN Single Cab',
    'TITAN XD Crew Cab',
    'TITAN XD King Cab',
    'TITAN XD Single Cab',
    'Versa',
    'Versa Note',
    '370Z',
  ],
  Volkswagen: [
    'Arteon',
    'Atlas',
    'Atlas Cross Sport',
    'Beetle',
    'e-Golf',
    'Golf',
    'Golf Alltrack',
    'Golf GTI',
    'Golf R',
    'Golf SportWagen',
    'Jetta',
    'Jetta GLI',
    'Passat',
    'Tiguan',
  ],
  Subaru: [
    'Ascent',
    'BRZ',
    'Crosstrek',
    'Forester',
    'Impreza',
    'Legacy',
    'Outback',
    'WRX',
  ],
  Cadillac: [
    'ATS',
    'ATS-V',
    'CT4',
    'CT5',
    'CT6',
    'CT6-V',
    'CTS',
    'CTS-V',
    'Escalade',
    'Escalade ESV',
    'XT4',
    'XT5',
    'XT6',
    'XTS',
  ],
  Toyota: [
    'Avalon',
    'Avalon Hybrid',
    'Camry',
    'Camry Hybrid',
    'C-HR',
    'Corolla',
    'Corolla Hatchback',
    'Corolla Hybrid',
    'GR Supra',
    'Highlander',
    'Highlander Hybrid',
    'Land Cruiser',
    'Mirai',
    'Prius',
    'Prius c',
    'Prius Prime',
    'RAV4',
    'RAV4 Hybrid',
    'Sequoia',
    'Sienna',
    'Tacoma Access Cab',
    'Tacoma Double Cab',
    'Tundra CrewMax',
    'Tundra Double Cab',
    'Yaris',
    'Yaris Hatchback',
    '4Runner',
    '86',
  ],
  Lamborghini: ['Aventador', 'Huracan', 'Urus'],
  Lincoln: [
    'Aviator',
    'Continental',
    'Corsair',
    'MKC',
    'MKT',
    'MKZ',
    'Nautilus',
    'Navigator',
    'Navigator L',
  ],
  Bentley: ['Bentayga', 'Continental', 'Mulsanne'],
  Chevrolet: [
    'Blazer',
    'Bolt EV',
    'Camaro',
    'Colorado Crew Cab',
    'Colorado Extended Cab',
    'Corvette',
    'Cruze',
    'Equinox',
    'Express 2500 Cargo',
    'Express 2500 Passenger',
    'Express 3500 Cargo',
    'Express 3500 Passenger',
    'Impala',
    'Malibu',
    'Silverado 1500 Crew Cab',
    'Silverado 1500 Double Cab',
    'Silverado 1500 LD Double Cab',
    'Silverado 1500 Regular Cab',
    'Silverado 2500 HD Crew Cab',
    'Silverado 2500 HD Double Cab',
    'Silverado 2500 HD Regular Cab',
    'Silverado 3500 HD Crew Cab',
    'Sonic',
    'Spark',
    'Suburban',
    'Tahoe',
    'Trailblazer',
    'Traverse',
    'Trax',
    'Volt',
  ],
  Kia: [
    'Cadenza',
    'Forte',
    'K900',
    'Niro',
    'Niro EV',
    'Niro Plug-in Hybrid',
    'Optima',
    'Optima Hybrid',
    'Optima Plug-in Hybrid',
    'Rio',
    'Sedona',
    'Seltos',
    'Sorento',
    'Soul',
    'Soul EV',
    'Sportage',
    'Stinger',
    'Telluride',
  ],
  Buick: [
    'Cascada',
    'Enclave',
    'Encore',
    'Encore GX',
    'Envision',
    'LaCrosse',
    'Regal Sportback',
    'Regal TourX',
  ],
  Porsche: [
    'Cayenne',
    'Cayenne Coupe',
    'Macan',
    'Panamera',
    'Taycan',
    '718 Boxster',
    '718 Cayman',
    '911',
  ],
  Dodge: [
    'Challenger',
    'Charger',
    'Durango',
    'Grand Caravan Passenger',
    'Journey',
  ],
  Jeep: [
    'Cherokee',
    'Compass',
    'Gladiator',
    'Grand Cherokee',
    'Renegade',
    'Wrangler',
    'Wrangler Unlimited',
  ],
  MINI: [
    'Clubman',
    'Convertible',
    'Countryman',
    'Hardtop 2 Door',
    'Hardtop 4 Door',
  ],
  MAZDA: [
    'CX-3',
    'CX-30',
    'CX-5',
    'CX-9',
    'MAZDA3',
    'MAZDA6',
    'MX-5 Miata',
    'MX-5 Miata RF',
  ],
  'Rolls-Royce': ['Dawn', 'Ghost', 'Phantom', 'Wraith'],
  'Aston Martin': ['DB11'],
  'Land Rover': [
    'Discovery',
    'Discovery Sport',
    'Range Rover',
    'Range Rover Evoque',
    'Range Rover Sport',
    'Range Rover Velar',
  ],
  Mitsubishi: [
    'Eclipse Cross',
    'Mirage',
    'Mirage G4',
    'Outlander',
    'Outlander PHEV',
    'Outlander Sport',
  ],
  Ford: [
    'EcoSport',
    'Edge',
    'Escape',
    'Expedition',
    'Expedition MAX',
    'Explorer',
    'F150 Regular Cab',
    'F150 Super Cab',
    'F150 SuperCrew Cab',
    'F250 Super Duty Crew Cab',
    'F250 Super Duty Regular Cab',
    'F250 Super Duty Super Cab',
    'F350 Super Duty Crew Cab',
    'F350 Super Duty Regular Cab',
    'F350 Super Duty Super Cab',
    'F450 Super Duty Crew Cab',
    'F450 Super Duty Regular Cab',
    'Fiesta',
    'Flex',
    'Fusion',
    'Fusion Energi',
    'Fusion Plug-in Hybrid',
    'Mustang',
    'Ranger SuperCab',
    'Ranger SuperCrew',
    'Taurus',
    'Transit 150 Van',
    'Transit 150 Wagon',
    'Transit 250 Van',
    'Transit 350 HD Van',
    'Transit 350 Van',
    'Transit 350 Wagon',
    'Transit Connect Cargo',
    'Transit Connect Cargo Van',
    'Transit Connect Passenger',
    'Transit Connect Passenger Wagon',
  ],
  Jaguar: ['E-PACE', 'F-PACE', 'F-TYPE', 'I-PACE', 'XE', 'XF', 'XJ'],
  Lexus: ['ES', 'GS', 'GX', 'IS', 'LC', 'LS', 'LX', 'NX', 'RC', 'RX', 'UX'],
  smart: [
    'fortwo electric drive',
    'fortwo electric drive cabrio',
    'fortwo EQ cabrio',
    'fortwo EQ coupe',
  ],
  Genesis: ['G70', 'G80', 'G90'],
  Maserati: ['Ghibli', 'GranTurismo', 'Levante', 'Quattroporte'],
  'Alfa Romeo': ['Giulia', 'Stelvio', '4C Spider'],
  Ferrari: ['GTC4Lusso', '488 GTB', '488 Spider', '812 Superfast'],
  BMW: [
    'i3',
    'i8',
    'M2',
    'M4',
    'M5',
    'M6',
    'X1',
    'X2',
    'X3',
    'X4',
    'X5',
    'X6',
    'X6 M',
    'X7',
    'Z4',
    '2 Series',
    '3 Series',
    '4 Series',
    '5 Series',
    '6 Series',
    '7 Series',
    '8 Series',
  ],
  Acura: [
    'ILX',
    'MDX',
    'MDX Sport Hybrid',
    'NSX',
    'RDX',
    'RLX',
    'RLX Sport Hybrid',
    'TLX',
  ],
  Tesla: ['Model 3', 'Model S', 'Model X'],
  Chrysler: ['Pacifica', 'Pacifica Hybrid', 'Voyager', '300'],
  Ram: [
    'ProMaster Cargo Van',
    'ProMaster City',
    'ProMaster Window Van',
    '1500 Classic Crew Cab',
    '1500 Classic Quad Cab',
    '1500 Classic Regular Cab',
    '1500 Crew Cab',
    '1500 Quad Cab',
    '2500 Crew Cab',
    '2500 Mega Cab',
    '2500 Regular Cab',
    '3500 Crew Cab',
    '3500 Mega Cab',
    '3500 Regular Cab',
  ],
  INFINITI: ['Q50', 'Q60', 'Q70', 'QX30', 'QX50', 'QX60', 'QX80'],
  Rivian: ['R1S', 'R1T'],
  Volvo: ['S60', 'S90', 'V60', 'V90', 'XC40', 'XC60', 'XC90'],
  Freightliner: [
    'Sprinter 2500 Cargo',
    'Sprinter 2500 Crew',
    'Sprinter 2500 Passenger',
    'Sprinter 3500 Cargo',
    'Sprinter 3500 Crew',
    'Sprinter 3500XD Cargo',
    'Sprinter 4500 Crew',
  ],
  FIAT: [
    '124 Spider',
    '500',
    '500 Abarth',
    '500c',
    '500c Abarth',
    '500e',
    '500L',
    '500X',
  ],
  McLaren: ['570GT', '570S', '720S'],
}

export const CAR_MAKES = Object.keys(CAR_MODELS).sort()

export const CAR_COLORS = [
  'Silver',
  'White',
  'Black',
  'Blue',
  'Gray',
  'Red',
  'Green',
  'Brown',
  'Gold',
  'Tan',
  'Orange',
  'Yellow',
  'Purple',
]
